




































import { Component, Vue } from "vue-property-decorator";
import { IBlock } from "@/interfaces";
import BlockService from "@/services/block";

@Component
export default class LastBlock extends Vue {
  private block: IBlock | null = null;

  public async mounted() {
    await this.prepareComponent();
  }

  private async prepareComponent() {
    await this.getBlock();

    this.$store.watch(
      (state) => state.network.height,
      (value) => this.getBlock(),
    );
  }

  private async getBlock() {
    const response = await BlockService.last();
    this.block = response;
  }
}
